import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from '../components/Layout'
import RoleProtectedRoute from './roleProtectedRoute'
import { adminRoutes } from './privateRoutes/adminRoutes'
import { publicRoutes } from './publicRoutes/publicRoutes'
import { nationalRoutes } from './privateRoutes/nationalRoutes'
import { barangayRoutes } from './privateRoutes/barangayRoutes'
import { residentRoutes } from './privateRoutes/residentRoutes'

const roleRouteMap = {
    admin: adminRoutes,
    national_official: nationalRoutes,
    barangay_official: barangayRoutes,
    resident: residentRoutes,
}

const allPrivateRoutes = Object.values(roleRouteMap).flat()

export const AppRouter = () => {
    return (
        <Routes>
            {publicRoutes.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
            ))}

            {allPrivateRoutes.map(({ path, element }) => (
                <Route
                    key={path}
                    path={path}
                    element={
                        <RoleProtectedRoute allowedRoles={Object.keys(roleRouteMap)}>
                            <Layout>{element}</Layout>
                        </RoleProtectedRoute>
                    }
                />
            ))}

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    )
}